<template>
  <div class="flex flex-dir-column app-layout orver-hidden-x" v-loading="queryLoading">
    <!-- 顶部搜索的表单 -->
    <div class="top-search padding-left-10 padding-right-10">
      <el-form
        align="left"
        size="mini"
        ref="topForm"
        :model="formQuery"
        label-width="0"
        :inline="true"
        class="flex flex-wrap"
      >
        <el-form-item label="平台应用" label-width="70px">
          <div class="flex">
            <system-select
              size="mini"
              isAutoSelect
            />
            <Version
              :os.sync="formQuery.os"
              :osVersion.sync="formQuery.osVersion"
              @update="() => {
                this.queryChartData()
                this.queryTableData(1)
              }"
              noShowVersionList
              isMergeVersion
            />
          </div>
        </el-form-item>
        <el-form-item class="margin-left-20">
          <el-date-picker
            v-model="formQuery.range"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right"
            unlink-panels
            :clearable="false"
            @change="() => {
              this.queryChartData()
              this.queryTableData(1)
            }"
            :picker-options="MonthPickerOptions"
          ></el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <el-row :gutter="20" class="padding-left-20 padding-right-20 padding-bottom-20">
      <!-- 设备分布 -->
      <el-card class="box-card">
        <div class="box-chart padding-top-20">
          <div class="title">TOP10版本分布</div>
          <!-- <el-radio-group
            v-model="versionPieQuery.userType"
            size="mini"
          >
            <el-radio-button
              v-for="item in userType"
              :key="item.value"
              :label="item.value"
            >{{ item.label }}</el-radio-button>
          </el-radio-group> -->
          <Echart
            :height="300"
            isMountedRender
            :id="'chartUserPie'"
            :data="chartDataUserPie"
            :type="'pie'"
          />
        </div>
      </el-card>
      <el-card class="box-card">
        <div class="box-chart padding-top-20">
          <div class="title">TOP10版本分布</div>
          <!-- <el-radio-group
            class="margin-bottom-20"
            v-model="versionLineQuery.userType"
            size="mini"
          >
            <el-radio-button
              v-for="item in userType"
              :key="item.value"
              :label="item.value"
            >{{ item.label }}</el-radio-button>
          </el-radio-group> -->
          <Echart
            :height="300"
            :id="'chartUserLine'"
            :data="chartDataUserLine"
            showData
            isMountedRender
            :isShowAreaStyle="false"
            :islinePlie="true"
          ></Echart>
        </div>
      </el-card>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>数据明细</span>
        </div>
        <div class="event-table flex-1 flex flex-column padding-top-20">
          <el-form
            align="left"
            size="mini"
            ref="topForm"
            :model="formQuery"
            :inline="true"
            class="flex flex-justify-between"
          >
            <el-form-item label="版本号">
              <el-input
                placeholder="请输入关键词"
                v-model="formQuery.version"
                @change="queryTableData(1)"
              />
            </el-form-item>
          </el-form>
          <el-table
            max-height="400px"
            :data="tableData"
            size="mini"
            stripe
          >
            <el-table-column
              v-for="(item, index) in columnsList"
              :width="item.width"
              :min-width="item.minWidth"
              :label="item.label"
              :prop="item.prop"
              :key="index"
              :fixed="item.fixed"
              :sortable="item.sortable"
            >
              <template #default="{ row }" v-if="item.tmpl">
                <template v-if="item.label === '总用户'">
                  <el-link
                    :undeline="false"
                    type="priamry"
                    @click="Object.assign(dialog, {
                      visible: true,
                      version: row.version,
                    })"
                  >{{ row[item.prop] }}</el-link>
                </template>
              </template>
            </el-table-column>
          </el-table>
          <!-- <el-row class="padding-20">
            <el-col align="right">
              <el-pagination
                class="analyze-users-pagination"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="tableQuery.pageNum"
                :page-sizes="[20, 50, 100, 200, 300, 400]"
                :page-size="tableQuery.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableQuery.total"
              ></el-pagination>
            </el-col>
          </el-row> -->
        </div>
      </el-card>
    </el-row>
    <DialogDetail :visible.sync="dialog.visible" :version="dialog.version"/>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import Moment from 'moment';
import {
  queryVersionList,
  queryVersionTendency,
  queryVersionCount,
} from '@/api/analyze';
import { MonthPickerOptions } from '@/data/picker-options';
import Echart from '@/views/components/echart/index.vue';
import Version from '../components/version.vue';
import DialogDetail from './components/dialog-detail.vue';

export default {
  components: { Echart, Version, DialogDetail },
  computed: {
    ...mapGetters('app', ['env', 'source', 'bizChannel']),
  },
  data() {
    return {
      dialog: {
        visible: false,
        version: '',
      },
      MonthPickerOptions,
      tableQuery: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
      },
      tableData: [],
      columnsList: [
        {
          label: '版本号',
          prop: 'version',
        },
        {
          label: '总用户',
          prop: 'userTotal',
          tmpl: true,
        },
        {
          label: '新增用户',
          prop: 'newUser',
        },
        {
          label: '新增用户占比',
          prop: 'newUserScale',
        },
        {
          label: '活跃用户',
          prop: 'activeUser',
        },
        {
          label: '活跃用户占比',
          prop: 'activeUserScale',
        },
      ],
      chartDataUserLine: {
        x: [''],
        y: [{ name: '暂无数据', data: [0] }],
      },
      chartDataUserPie: {
        name: '暂无数据',
        data: [
          {
            value: 0,
            name: '',
          },
        ],
      },
      userType: [
        { label: '全部用户', value: '' },
        { label: '活跃用户', value: 0 },
        { label: '新用户', value: 1 },
      ],
      versionLineQuery: {
        userType: '',
      },
      versionPieQuery: {
        userType: '',
      },
      formQuery: {
        range: [],
        version: '',
        osVersion: '',
        eventCode: '',
        os: '',
      },
      pageEvents: [],
      queryLoading: false,
    };
  },
  mounted() {
    const today = Moment().format('YYYY-MM-DD');
    const today2 = Moment().subtract(7, 'days').format('YYYY-MM-DD');
    this.formQuery.range = [new Date(today2), new Date(today)];
    this.queryChartData();
    this.queryTableData(1);
  },
  watch: {
    source: {
      handler(val) {
        if (val !== '') {
          this.queryChartData();
          this.queryTableData(1);
        } else {
          this.$message.warning('请先选择应用');
        }
      },
    },
    bizChannel: {
      handler() {
        if (this.source !== '') {
          this.queryChartData();
          this.queryTableData(1);
        }
      },
    },
  },
  methods: {
    async queryTableData(currentPageNum) {
      if (currentPageNum) {
        this.tableQuery.pageNum = currentPageNum;
      }
      try {
        this.queryLoading = true;

        const {
          pageNum,
          pageSize,
        } = this.tableQuery;
        const {
          osVersion,
          os,
          version,
          range,
        } = this.formQuery;
        const analyzeTimeTo = `${Moment(range[1]).format('YYYY-MM-DD')} 23:59:59`;
        const analyzeTimeFrom = `${Moment(range[0]).format('YYYY-MM-DD')} 00:00:00`;

        const params = {
          pageNum,
          pageSize,
          version,
          analyzeTimeTo,
          analyzeTimeFrom,
          topCount: 10,
          os,
          osVersion,
        };

        const {
          data,
        } = await queryVersionList(params);
        // this.tableQuery.total = total;
        this.tableData.splice(0, this.tableData.length, ...(data || []));
      } finally {
        this.queryLoading = false;
      }
    },
    handleSizeChange(size) {
      this.tableQuery.pageSize = size;
      this.tableQuery.pageNum = 1;
      this.queryTableData();
    },
    handleCurrentChange(num) {
      this.tableQuery.pageNum = num;
      this.queryTableData();
    },
    resetChartData(data = {
      versions: [],
      appVersionTendencies: [{
        appVersionCounts: [],
        analyzeTimeFrom: '',
      }],
    }) {
      const {
        versions,
        appVersionTendencies,
      } = data;
      const { range } = this.formQuery;
      const analyzeTimeTo = Moment(range[1]).format('YYYY-MM-DD');
      const analyzeTimeFrom = Moment(range[0]).format('YYYY-MM-DD');
      // eslint-disable-next-line operator-linebreak
      const days = Moment(analyzeTimeTo).diff(Moment(analyzeTimeFrom), 'days') + 1;

      const xList = [];
      const yList = [];

      if (versions.length) {
        versions.forEach((item) => {
          yList.push({ name: item, data: new Array(days).fill(0) });
        });
      } else {
        yList.push({ name: '暂无数据', data: [0] });
      }

      // 计算相差多少天, X轴坐标
      for (let i = 0, len = days; i < len; i++) {
        const time = Moment(analyzeTimeFrom).add(i, 'days').format('YYYY-MM-DD');
        xList.push(time);

        // 是否查找到对应日期
        const checkIsFindData = appVersionTendencies.some((item) => {
          if (item.analyzeTimeFrom.indexOf(time) !== -1) {
            // 查找到对应日期
            const {
              appVersionCounts,
            } = item;
            appVersionCounts.forEach(({ version, count }) => {
              const findIndex = versions.findIndex((index) => index === version);

              yList[findIndex].data[i] = count || 0;
            });

            return true;
          }
          return false;
        });

        if (!checkIsFindData) {
          // 返回的数据没有对应的日期展示，需要默认填充0
          yList.forEach((_item, index) => {
            yList[index].data[i] = 0;
          });
        }

        // const filter = appVersionTendencies
        //   .fliter((item) => item.analyzeTimeFrom.indexOf(time) !== -1);

        // // 查到当前月的版本数据
        // const appVersionCounts = filter.length ? filter[0].appVersionCounts : [];

        // if (appVersionCounts?.length) {
        //   appVersionCounts.forEach(({ version, count }) => {
        //     const findIndex = versions.findIndex((index) => index === version);

        //     yList[findIndex].data.push(count);
        //   });
        // }
      }

      this.chartDataUserLine.x.splice(0, this.chartDataUserLine.x.length, ...xList);
      this.chartDataUserLine.y.splice(0, this.chartDataUserLine.y.length, ...yList);
    },
    resetPieChartData(data = []) {
      if (!data.length) {
        this.$set(this, 'chartDataUserPie', {
          name: '暂无数据',
          data: [
            {
              value: 0,
              name: '',
            },
          ],
        });
      } else {
        const pieData = [];
        data.forEach(({ version, count }) => {
          pieData.push({
            value: count,
            name: version,
          });
        });
        this.chartDataUserPie.name = '';
        this.chartDataUserPie.data.splice(0, this.chartDataUserPie.data.length, ...pieData);
      }
    },
    async queryVersionCount(params) {
      try {
        const { data } = await queryVersionCount(params);

        this.resetPieChartData(data);
        // return data;
      } catch (e) {
        this.resetPieChartData([]);
        // return [];
      }
    },
    async queryVersionTendency(params) {
      try {
        const { data } = await queryVersionTendency(params);

        this.resetChartData(data || {
          versions: [],
          appVersionTendencies: [],
        });
        // return data;
      } catch (e) {
        this.resetChartData();
        // return [];
      }
    },
    async queryChartData() {
      this.queryLoading = true;
      try {
        const {
          range,
          osVersion,
          os,
        } = this.formQuery;
        const analyzeTimeTo = `${Moment(range[1]).format('YYYY-MM-DD')} 23:59:59`;
        const analyzeTimeFrom = `${Moment(range[0]).format('YYYY-MM-DD')} 00:00:00`;

        const params = {
          analyzeTimeTo,
          analyzeTimeFrom,
          osVersion,
          os,
          topCount: 10,
        };

        await this.queryVersionCount(params);
        await this.queryVersionTendency(params);
      } catch (error) {
        console.error(error);
      } finally {
        this.queryLoading = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.box-card {
  border: 0;
  text-align: left;
  margin-bottom: 20px;
  &::v-deep {
    .el-card__body {
      padding-top: 0;
    }
  }
  &-echart {
    background: transparent;
    // max-height: 400px;
    overflow: auto;
  }
}
.app-layout {
  height: calc(100vh - 0);
  min-width: 800px;
  margin: 15px 0 0;
}
// .top-search {
//   position: fixed;
//   top: 95px;
//   left: 15px;
//   right: 15px;
//   padding: 30px 20px 0;
//   background: #fff;
//   z-index: 99;
//   text-align: left;
//   border-radius: 5px;
// }
.box-chart {
  .title {
    font-size: 15px;
    font-weight: bold;
    margin-bottom: 10px;
  }
}
</style>
